import MuiButton from './MuiButton';
import MuiToggleButton from './MuiToggleButton';
import MuiToggleButtonGroup from './MuiToggleButtonGroup';
import MuiTextField from './MuiTextField';
import MuiInputBase from './MuiInputBase';
import MuiFilledInput from './MuiFilledInput';
import MuiAutocomplete from './MuiAutocomplete';
import MuiDivider from './MuiDivider';
import MuiInputLabel from './MuiInputLabel';
import MuiDialogContent from './MuiDialogContent';
import MuiSlider from './MuiSlider';
import MuiTabs from './MuiTabs';
import MuiTab from './MuiTab';
import MuiAccordion from './MuiAccordion';
import MuiAccordionSummary from './MuiAccordionSummary';
import MuiAccordionDetails from './MuiAccordionDetails';
import MuiFormControlLabel from './MuiFormControlLabel';
import MuiToolbar from './MuiToolbar';
import MuiSnackbar from './MuiSnackbar';
import MuiAlert from './MuiAlert';
import MuiTooltip from './MuiTooltip';

export default {
  ...MuiButton,
  ...MuiToggleButton,
  ...MuiTextField,
  ...MuiInputBase,
  ...MuiFilledInput,
  ...MuiAutocomplete,
  ...MuiDivider,
  ...MuiInputLabel,
  ...MuiDialogContent,
  ...MuiSlider,
  ...MuiTabs,
  ...MuiTab,
  ...MuiAccordion,
  ...MuiAccordionSummary,
  ...MuiAccordionDetails,
  ...MuiToggleButtonGroup,
  ...MuiFormControlLabel,
  ...MuiToolbar,
  ...MuiSnackbar,
  ...MuiAlert,
  ...MuiTooltip,
};
